import { Deserializable } from '../protocols/deserializable';
import { Attachment } from '../submissions/attachment';
import { ContributionTypeEnum } from '../../features/new-contribution/enums/contribution-type.enum';
import { MemberContributionFrequencyEnum } from '../enum/shared/member-contribution-frequency-enum';
import { MemberContributionSourceEnum } from '../enum/shared/member-contribution-source-enum';
import { PaymentMethodTypeEnum } from '../enum/shared/payment-method-type-enum';
import { MemberContributionType } from '../types/dto/member-contribution-type';
import { MemberContributionSourceType } from '../types/dto/member-contribution-source-type';
import { MemberContributionFrequencyType } from '../types/dto/member-contribution-frequency-type';
import { PaymentMethodType } from '../types/dto/payment-method-type';

export class MemberScheduledContribution implements Deserializable {
  public id!: number;
  public memberId!: number;
  public memberName!: string;
  public contributionTypeId!: ContributionTypeEnum;
  public contributionType!: MemberContributionType;
  public sourceId!: MemberContributionSourceEnum;
  public source!: MemberContributionSourceType;
  public amount!: number;
  public note!: string | null;
  public frequencyId!: MemberContributionFrequencyEnum;
  public frequency!: MemberContributionFrequencyType;
  public name!: string;
  public startDate!: string;
  public endDate!: string | null;
  public nextContributionDate!: string | null;
  public paymentMethodTypeId!: PaymentMethodTypeEnum;
  public paymentMethodType!: PaymentMethodType;
  public paymentMethod!: string | null;
  public creditCardId!: number | null;
  public bankAccountId!: number | null;
  public spouseId!: number | null;
  public createdDate!: string;
  public attachment!: Attachment | null;

  onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;
    if (this.contributionType) {
      this.contributionType = Deserialize?.instanceOf(MemberContributionType, this.contributionType);
    }

    if (this.source) {
      this.source = Deserialize?.instanceOf(MemberContributionSourceType, this.source);
    }

    if (this.frequency) {
      this.frequency = Deserialize?.instanceOf(MemberContributionFrequencyType, this.frequency);
    }

    if (this.paymentMethodType) {
      this.paymentMethodType = Deserialize?.instanceOf(PaymentMethodType, this.paymentMethodType);
    }

    if (this.attachment) {
      this.attachment = Deserialize?.instanceOf(Attachment, this.attachment);
    }
  }
}
